// SiteUp: seções de topo da barra lateral que o usuário pode ocultar/mostrar
// nas Configurações de Perfil. O `name` PRECISA bater com o `name` do item
// correspondente em Sidebar.vue (menuItems) — é por ele que o filtro funciona.
//
// `routeName`: rota representativa da seção (o item em si, ou o 1º filho dos
// itens que têm submenu). Serve pra ler o `meta` da rota (permissões/feature/
// installationType) e decidir se a seção aparece pro usuário — exatamente o que
// a barra faz (SidebarGroup -> isAllowed). Assim itens escondidos por cargo
// (ex.: Relatórios/Configurações só pra admin) não aparecem na lista.
//
// `featureFlag` (quando presente): gate extra por feature da conta, espelhando o
// prop usado no menuItems. Cargo continua valendo pelo `routeName`.
//
// `label` (texto fixo) tem prioridade sobre `labelKey` (i18n).
export const SIDEBAR_MENU_SECTIONS = [
  { name: 'Inbox', labelKey: 'SIDEBAR.INBOX', routeName: 'inbox_view' },
  {
    name: 'Conversation',
    labelKey: 'SIDEBAR.CONVERSATIONS',
    routeName: 'home',
  },
  {
    name: 'InternalChat',
    labelKey: 'SIDEBAR.INTERNAL_CHAT',
    routeName: 'internal_chat',
  },
  {
    name: 'Kanban',
    label: 'Kanban',
    featureFlag: 'kanban_board',
    routeName: 'kanban_board',
  },
  {
    name: 'Scheduled Messages',
    labelKey: 'SCHEDULE_MESSAGES.LIST.TITLE',
    featureFlag: 'kanban_board',
    routeName: 'kanban_board',
  },
  {
    name: 'Flow automations',
    labelKey: 'SIDEBAR.FLOW_AUTOMATIONS',
    featureFlag: 'kanban_board',
    routeName: 'conversation_workflows_index',
  },
  { name: 'Tasks', label: 'Tarefas', routeName: 'tasks' },
  {
    name: 'Permutas',
    label: 'Permutas',
    featureFlag: 'permutas',
    routeName: 'permutas_index',
  },
  {
    name: 'Captain',
    labelKey: 'SIDEBAR.CAPTAIN',
    routeName: 'captain_assistants_index',
  },
  {
    name: 'Contacts',
    labelKey: 'SIDEBAR.CONTACTS',
    routeName: 'contacts_dashboard_active',
  },
  {
    name: 'Companies',
    labelKey: 'SIDEBAR.COMPANIES',
    routeName: 'companies_dashboard_index',
  },
  {
    name: 'Reports',
    labelKey: 'SIDEBAR.REPORTS',
    routeName: 'account_overview_reports',
  },
  {
    name: 'Campaigns',
    labelKey: 'SIDEBAR.CAMPAIGNS',
    routeName: 'campaigns_livechat_index',
  },
  {
    name: 'Email Sequences',
    label: 'Sequências Email',
    featureFlag: 'email_sequences',
    routeName: 'email_sequences',
  },
  {
    name: 'WhatsApp Groups',
    label: 'Grupos WhatsApp',
    featureFlag: 'whatsapp_groups',
    routeName: 'whatsapp_groups_campaigns',
  },
  {
    name: 'Comment to DM',
    label: 'Comentário IG → DM',
    routeName: 'instagram_automation_index',
  },
  {
    name: 'FB Comment to DM',
    label: 'Comentário FB → DM',
    routeName: 'facebook_automation_index',
  },
  {
    name: 'Voip Calls',
    labelKey: 'SIDEBAR.VOIP_CALLS',
    featureFlag: 'voip_calls',
    routeName: 'voip_calls',
  },
  {
    name: 'Help Center',
    labelKey: 'SIDEBAR.HELP_CENTER.TITLE',
    routeName: 'help_center_index',
  },
  {
    name: 'Settings',
    labelKey: 'SIDEBAR.SETTINGS',
    routeName: 'general_settings_index',
  },
];
